import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from "lodash-es";

const MODULE_PREFIX = "[ REFERRAL ]";

// Actions
const Actions = {
  getSelectedTab: `${MODULE_PREFIX} getSelectedTab`,
  setSelectedTab: `${MODULE_PREFIX} setSelectedTab`,
  getActiveCampaigns: `${MODULE_PREFIX} getActiveCampaigns`,
  setActiveCampaigns: `${MODULE_PREFIX} setActiveCampaigns`,
  getRefereeList: `${MODULE_PREFIX} getRefereeList`,
  setRefereeList: `${MODULE_PREFIX} setRefereeList`,
  getWalletTransactions: `${MODULE_PREFIX} getWalletTransactions`,
  setWalletTransactions: `${MODULE_PREFIX} setWalletTransactions`,
  getWalletBalance: `${MODULE_PREFIX} getWalletBalance`,
  setWalletBalance: `${MODULE_PREFIX} setWalletBalance`,
  getTnc: `${MODULE_PREFIX} getTnc`,
  setTnc: `${MODULE_PREFIX} setTnc`,
};

export const getSelectedTab = createAction(Actions.getSelectedTab);
export const setSelectedTab = createAction(Actions.setSelectedTab);
export const getActiveCampaigns = createAction(Actions.getActiveCampaigns);
export const setActiveCampaigns = createAction(Actions.setActiveCampaigns);
export const getWalletTransactions = createAction(
  Actions.getWalletTransactions
);
export const setWalletTransactions = createAction(
  Actions.setWalletTransactions
);
export const getRefereeList = createAction(Actions.getRefereeList);
export const setRefereeList = createAction(Actions.setRefereeList);
export const getWalletBalance = createAction(Actions.getWalletBalance);
export const setWalletBalance = createAction(Actions.setWalletBalance);
export const getTnc = createAction(Actions.getTnc);
export const setTnc = createAction(Actions.setTnc);

export const getSelectedTabIndex = (state) => {
  return get(state, "referAndEarn.selectedTab", 0);
};

export const getActiveCampaignsData = (state) => {
  return get(state, "referAndEarn.activeCampaigns.data", []);
};

export const getActiveCampaignsTitle = (state) => {
  return get(state, "referAndEarn.activeCampaigns.title", "");
};

export const getActiveCampaignsShareMessage = (state) => {
  return get(state, "referAndEarn.activeCampaigns.shareMessage", "");
};

export const getRefereeListData = (state) => {
  return get(state, "referAndEarn.refereeList", []);
};

export const getWalletTransactionsData = (state) => {
  return get(state, "referAndEarn.walletTransactions", []);
};

export const getWalletBalanceData = (state) => {
  return get(state, "referAndEarn.walletBalance", {});
};

export const getTncData = (state) => {
  return get(state, "referAndEarn.tncPoints", []);
};

const initialState = {
  selectedTab: 0,
  activeCampaigns: {},
  refereeList: [],
  walletTransactions: [],
  walletBalance: {},
  tncPoints: [],
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setActiveCampaigns, (state, action) => {
    const { title, shareMessage, data } = action.payload;
    state.activeCampaigns = { title, shareMessage, data };
  });
  builder.addCase(setRefereeList, (state, action) => {
    const refereeList = action.payload;
    state.refereeList = refereeList;
  });
  builder.addCase(setWalletBalance, (state, action) => {
    const balance = action.payload;
    state.walletBalance = balance;
  });
  builder.addCase(setWalletTransactions, (state, action) => {
    const transactions = action.payload;
    state.walletTransactions = transactions;
  });
  builder.addCase(setTnc, (state, action) => {
    const tncPoints = action.payload;
    state.tncPoints = tncPoints;
  });
  builder.addCase(setSelectedTab, (state, action) => {
    state.selectedTab = action.payload;
  });
});
